import { Alert, Modal } from "react-bootstrap";
import { FC, useState } from "react";
import Swal from "sweetalert2";

interface ModalResetOptionsProps {
    showModal: boolean;
    account_id: number;
    account: any;
    handleClose: () => void;
    reset_account: (option: string, account_id: number) => void;
}

const options = [
    { id: "option1", value: "1", label: "Start on IBV", section: "IBV in Welcome Page" },
    { id: "option2", value: "2", label: "Start on Mapping Verification (No IBV data)", section: "Mapping Verification" },
    { id: "option3", value: "3", label: "Start on Mapping Verification (Latest IBV data)", section: "Mapping Verification with IBV data" },
    { id: "option4", value: "4", label: "Scoreboard (No IBV data, No Mapping Verification data, empty account)", section: "Scoreboard" },
];

const ModalResetOptions: FC<ModalResetOptionsProps> = ({ showModal, handleClose, account_id, reset_account, account }) => {
    const [selectedOption, setSelectedOption] = useState<string | null>(null);

    // Handle radio button change
    const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(e.target.value);
    };

    // Confirm reset options with SweetAlert2
    const confirmResetOptions = () => {
        if (selectedOption === null) return;
        // Create message according to selected option
        const msg = options.find(option => option.value === selectedOption)?.section;

        Swal.fire({
            title: `Are you sure to reset account?`,
            html: `<p class="text-left">Reset user to: <b>${msg}</b>.</p>
            <div class="alert alert-danger mt-3">This action cannot be undone!</div>
            `,
            customClass: "swal2-radio-custom",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                reset_account(selectedOption, account_id);
            }
        });
    };

    return (
        <Modal show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Reset Account: <u>{account.name}</u></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>This action will permanently erase ALL USER DATA and restore the account to its default state.</p>
                <Alert variant="warning">Choose the option to reset the account</Alert>
                {options.map(option => (
                    <div className="form-check" key={option.id}>
                        <input
                            onChange={handleOptionChange}
                            className="form-check-input"
                            type="radio"
                            name="resetOption"
                            id={option.id}
                            value={option.value}
                        />
                        <label className="form-check-label" htmlFor={option.id}>
                            {option.label}
                        </label>
                    </div>
                ))}
                <div className="d-flex justify-content-center mt-5">
                    <button
                        className="btn btn-default"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>
                    <button
                        disabled={selectedOption === null}
                        className="btn btn-primary"
                        onClick={confirmResetOptions}
                    >
                        Reset Account
                    </button>

                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalResetOptions;
